import i18next from 'app/translations/i18n';

export const MODEL_TEXT = 'learningObjectives';

export const ModelErrors = [
  {
    code: 'MAX_LENGTH',
    path: 'learning_objective',
    message: i18next.t('settings:error_learning_objective_max_length'),
  },
];
